/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas/:workflow_id/versions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../../reactQueryFetcherAdapters";
import { engagementCanvasVersionsWorkflowIdAppGroupId } from "./constants";
import type { CanvasVersionsResult } from "./types";

export const getCanvasVersions = reactQueryFetcherAdapter(
  engagementCanvasVersionsWorkflowIdAppGroupId,
  (signal: AbortSignal, workflowId: string, appGroupId: string): Promise<CanvasVersionsResult[]> => {
    return fetch(`/engagement/${appGroupId}/canvas/${workflowId}/versions`, "GET", { signal });
  }
);
